import { Box, Stack, Heading, Text, Button, Alert } from 'braid-design-system';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NotFoundPage = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    return (
        <Box padding="large" display="flex" alignItems="center" justifyContent="center">
            <Stack space="large" align="center">
                <Heading level="1" align="center">
                    {t('page.not_found.heading', { defaultValue: '404 - Page Not Found' })}
                </Heading>
                <Alert tone="caution">
                    <Text>{t('page.not_found.message', { defaultValue: 'Sorry, the page you are looking for does not exist.' })}</Text>
                </Alert>
                <Text tone="secondary" align="center">
                    {t('page.not_found.instructions_line1', { defaultValue: 'Please check the URL or return to the home page.' })} <br />
                    {t('page.not_found.instructions_line2', { defaultValue: 'Please contact the administrator if you believe this is an error.' })}
                </Text>
                <Button variant="ghost" onClick={() => navigate('/')}>{t('page.not_found.button.go_home', { defaultValue: 'Go to Home' })}</Button>
            </Stack>
        </Box>
    );
};

export default NotFoundPage;
